<main class="appointments">
    <app-vinavon-button>
        <button mat-fab matTooltip="{{ 'MAIN_APP_PENDENZEN.neueAufgabe' | translate }}" (click)="onNewAufgabe()" style="background-color: #ffffff" class="medium">
            <mat-icon class="low">rule</mat-icon>
        </button>

        <button mat-fab matTooltip="{{ 'MAIN_APP_PENDENZEN.neueNotiz' | translate }}" (click)="onNewNote()" style="background-color: #ffffff" class="medium">
            <mat-icon class="low">content_paste</mat-icon>
        </button>

        <button mat-fab matTooltip="{{ 'MAIN_APP_PENDENZEN.neuerTermin' | translate }}" (click)="onNewTermin()" style="background-color: #ffffff" class="medium">
            <mat-icon class="low">assignment</mat-icon>
        </button>

        <button mat-fab matTooltip="{{ 'MAIN_APP_PENDENZEN.löschen' | translate }}" (click)="delSelectedItem()" style="background-color: #ffffff" class="medium">
            <mat-icon class="low">delete_forever</mat-icon>
        </button>

        <ejs-multiselect
            id="mitarbeiterListe"
            [dataSource]="mitarbeiterDataSource()"
            [value]="selectedMitarbeiter()"
            [mode]="'Default'"
            [fields]="fields"
            [placeholder]="mitarbeiterAuswahl"
            (select)="onSelect($event)"
            (removed)="onRemoved($event)"
        ></ejs-multiselect>
    </app-vinavon-button>

    <mat-card appearance="outlined" style="padding: 0 16px">
        <div class="contentBox">
            <div>{{ currentAppointment() }}</div>
            <div>
                <button mat-mini-fab color="primary" class="fabButtonSmall" (click)="showAppointmentDetails()" [disabled]="!currPendenzExists()">
                    <mat-icon>preview</mat-icon>
                </button>
            </div>
        </div>
    </mat-card>
    <div style="overflow-y: auto; height: 100%; flex: 1">
        <div>
            <app-calendar (appointmentSelected)="reloadAppointment($event)" (timeRangeSelected)="onTimeRangeSelected($event)"></app-calendar>
        </div>
    </div>
</main>
